// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"763":"87e9ffa5","8795":"d66e6288","9741":"b82fe579","9874":"4b594109"}[chunkId] + ".chunk.css";
};